import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { IoIosSearch } from "react-icons/io";
import {
  Container,
  Image,
  Form,
  Modal,
  InputGroup,
  Spinner,
} from "react-bootstrap";

import "bootstrap/dist/css/bootstrap.min.css";
import "./job-title.css";

import logo from "../../../assets/images/MTDlogo.png";
import backarrow from "../../../assets/images/backarrow.jpg";
import responsivebg from "../../../assets/images/responsive-bg.png";

import Stepper from "../Stepper";
import * as userActions from "../../../actions/user";
import * as masterConstantActions from "../../../actions/masterConstant";
import { showAlert } from "../../../utils/alertUtils";

export const JobTitle = () => {
  const isFetched = useRef(false);
  const [jobTypes, setJobTypes] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [customJobs, setCustomJobs] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [newJobTitle, setNewJobTitle] = useState("");
  const [selectedOption, setSelectedOption] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const jobListEndRef = useRef(null);
  const [hasAddedJob, setHasAddedJob] = useState(false);
  const jobListContainerRef = useRef(null);

  const navigate = useNavigate();

  // Fetch master job types
  const fetchJobTypes = async () => {
    try {
      const response = await masterConstantActions.getConstantJobs();
      if (response.status && Array.isArray(response.data)) {
        const uniqueJobs = [];
        const jobSet = new Set();

        response.data.forEach((job) => {
          const jobName = job.name.trim().toLowerCase();
          if (!jobSet.has(jobName)) {
            uniqueJobs.push(job);
            jobSet.add(jobName);
          }
        });

        setJobTypes(uniqueJobs);
      }
    } catch (error) {
      console.error("Error fetching job types:", error);
    }
  };

  // Fetch user job
  const fetchUserJob = async () => {
    try {
      const response = await userActions.getUserJobs();
      if (response && response.jobs?.length > 0) {
        setSelectedOption(response.jobs[0].name);
      }
    } catch (error) {
      console.error("Error fetching user job:", error);
    }
  };

  useEffect(() => {
    if (isFetched.current) return;
    isFetched.current = true;

    fetchJobTypes();
    fetchUserJob();
  }, []);
  useEffect(() => {
    if (hasAddedJob && jobListEndRef.current && jobListContainerRef.current) {
      const container = jobListContainerRef.current;
      const element = jobListEndRef.current;

      const containerRect = container.getBoundingClientRect();
      const elementRect = element.getBoundingClientRect();

      const isOutOfView =
        elementRect.bottom > containerRect.bottom ||
        elementRect.top < containerRect.top;

      if (isOutOfView) {
        element.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "nearest",
        });
      }

      setHasAddedJob(false);
    }
  }, [hasAddedJob]);

  const handleSave = () => {
    const jobTitle = newJobTitle.trim();
    if (!jobTitle) {
      showAlert("Error", "Job title cannot be empty.");
      return;
    }

    const isDuplicate = [...jobTypes, ...customJobs].some(
      (job) => job.name.toLowerCase() === jobTitle.toLowerCase()
    );

    if (isDuplicate) {
      showAlert("Error", "Job title already exists.");
      return;
    }

    const newJob = { id: `custom-${customJobs.length + 1}`, name: jobTitle };
    setCustomJobs((prev) => [...prev, newJob]);
    setShowModal(false);
    setNewJobTitle("");
    setHasAddedJob(true);
  };

  const filteredJobs = [...jobTypes, ...customJobs].filter((job) =>
    job.name.toLowerCase().includes(searchTerm.toLowerCase())
  );
  const saveJobTitle = async () => {
    if (!selectedOption) {
      setErrorMessage("*Please make a selection.");
      return;
    }
    setLoading(true);
    const response = await userActions.updateUserJobs({
      name: selectedOption,
    });

    setLoading(false);

    if (response) {
      navigate("/height");
    }
  };

  return (
    <div className="job-container">
      <div className="job-bg">
        <Image className="banner-image" src={responsivebg} alt="Background" />
      </div>
      <Container className="job-main">
        <Container className="job-content">
          <Container className="logo-progressbar">
            <Container className="logo-arrow">
              <Image
                src={backarrow}
                className="backarrow"
                onClick={() => window.history.back()}
                alt="Back Arrow"
              />
              <Image
                src={logo}
                alt="Logo"
                className="logo"
                style={{ backgroundColor: "transparent" }}
              />
            </Container>
            <Stepper activeStep="JobTitle" />
          </Container>

          <Container className="job-details-container">
            <Container className="job-details">
              <div className="container-child1">
                <div className="your-job">
                  <Container className="job-text">
                    <p>What’s your job title?</p>
                  </Container>

                  <InputGroup className="job-search-bar">
                    <Form.Control
                      className="job-search"
                      type="text"
                      placeholder="Search"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                    <InputGroup.Text className="search-icon">
                      <IoIosSearch />
                    </InputGroup.Text>
                  </InputGroup>

                  <Container className="all-job" ref={jobListContainerRef}>
                    <div className="job-columns">
                      {filteredJobs?.map((job) => (
                        <div
                          key={job.id}
                          onClick={() => setSelectedOption(job?.name)}
                          className="job-item"
                          style={{
                            backgroundColor:
                              selectedOption == job?.name
                                ? "#F7ECFF"
                                : "transparent",
                          }}
                        >
                          {job.name}
                        </div>
                      ))}
                      <div ref={jobListEndRef} className="job-end-marker" />
                    </div>
                  </Container>

                  <div className="not-seeing-job">
                    Not seeing your job?{" "}
                    <button
                      className="btn btn-underline"
                      onClick={() => setShowModal(true)}
                    >
                      Add here
                    </button>
                  </div>
                </div>
                {errorMessage && (
                  <p className="text-danger error-message">{errorMessage}</p>
                )}
              </div>
            </Container>
          </Container>

          <Container className="job-next-btn">
            <div className="d-flex justify-content-center job-next-btn">
              <button
                type="submit"
                className="global-next-bottom-fix-btn"
                onClick={saveJobTitle}
              >
                {loading ? (
                  <Spinner animation="border" size="sm" role="status" />
                ) : (
                  "Next"
                )}
              </button>
            </div>
          </Container>
        </Container>
      </Container>

      <Modal
        className="customer-modal-without-header-footer"
        show={showModal}
        centered
        onHide={() => setShowModal(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title className="job-model-title">
            Add your job title
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="job-modal-body">
          <Form.Control
            className="job-model-form"
            type="text"
            placeholder="Type here..."
            value={newJobTitle}
            onChange={(e) => setNewJobTitle(e.target.value)}
          />
        </Modal.Body>
        <Modal.Footer className="job-model-footer">
          <button
            className="global-cancel-button"
            onClick={() => setShowModal(false)}
          >
            Cancel
          </button>
          <button className="global-save-button" onClick={handleSave}>
            Save
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
